import {defaultTransformFn, dsApi} from "api/rtkQueryApi/DsApi";
import {Agreement} from "../entities/Agreement";
import {ESignPlanAgreement} from "api/entities/ESignPlanAgreement";

const agreementsTags = dsApi.enhanceEndpoints({addTagTypes: ["Agreement"]});

const agreementsApi = agreementsTags.injectEndpoints({
    endpoints: (build) => ({
        sendESignLink: build.mutation<
            string,
            { agreementId: string; email: string; eSignLink: string }
        >({
            query: ({agreementId, email, eSignLink}) => {
                return {
                    url: `agreements/${agreementId}/sendESignLink?email=${encodeURIComponent(email)}&eSignLink=${encodeURIComponent(eSignLink)}`,
                    method: "POST",
                };
            },
            transformResponse: defaultTransformFn,
        }),
        getAllAgreements: build.query<Agreement[], void>({
            query: () => {
                return {
                    url: "agreements",
                    method: "GET",
                };
            },
            transformResponse: defaultTransformFn,
        }),
        getMyAgreements: build.query<Agreement[], void>({
            query: () => {
                return {
                    url: "agreements/mine",
                    method: "GET",
                };
            },
            transformResponse: defaultTransformFn,
        }),
        createESignToken: build.mutation<string, { agreementId: string }>({
            query: ({agreementId}) => {
                return {
                    url: `agreements/${agreementId}/eSignToken`,
                    method: "POST",
                };
            },
            transformResponse: defaultTransformFn,
        }),
        signAgreement: build.mutation<Agreement, { agreementId: string }>({
            query: ({agreementId}) => {
                return {
                    url: `agreements/${agreementId}/sign`,
                    method: "POST",
                };
            },
            transformResponse: defaultTransformFn,
        }),
        getPlanAgreementWithESignToken: build.query<
            ESignPlanAgreement,
            { eSignToken: string }
        >({
            query: ({eSignToken}) => {
                return {
                    url: `eSignToken/agreement/${eSignToken}`,
                    method: "GET",
                };
            },
            transformResponse: defaultTransformFn,
        }),
        signAndActivatePlan: build.mutation<
            boolean,
            { eSignToken: string; file: File }
        >({
            query: ({eSignToken, file}) => {
                const formData = new FormData();
                formData.append("file", file);

                return {
                    url: `eSignToken/signAndActivatePlan/${eSignToken}`,
                    method: "POST",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: formData,
                };
            },
            transformResponse: defaultTransformFn,
        }),
    }),
});

export const {
    useSendESignLinkMutation,
    useGetAllAgreementsQuery,
    useGetMyAgreementsQuery,
    useCreateESignTokenMutation,
    useSignAgreementMutation,
    useGetPlanAgreementWithESignTokenQuery,
    useSignAndActivatePlanMutation,
} = agreementsApi;
